import moment from "moment";
import createRestApiClient from "./createRestApiClient";

import capitalize from "lodash/capitalize";
import get from "lodash/get";

import {
  CHROME,
  COMET,
  EDGE,
  ELECTRON,
  FIREFOX,
  INTERNET_EXPLORER,
  MOBILE,
  OPERA,
  PW_CHROMIUM,
  PW_FIREFOX,
  PW_WEBKIT,
  SAFARI,
  WEBKIT,
  YANDEX
} from "../common/constants/Browsers";

import {
  BuildTestGroups,
  BuildTestTabs,
  DemoTestIds,
  TestCategories,
  TestTypes
} from "../common/constants/View";
import { EventsMap } from "../common/constants/events";
import { LogsType } from "../components/Logs/constants";
import defaultBrowserIcon from "../images/browser.svg";
import cometIcon from "../images/comet.svg";
import appiumIcon from "../images/ml2.0/appium.svg";
import chromeIcon from "../images/ml2.0/browsers/chrome.svg";
import chromiumIcon from "../images/ml2.0/browsers/chromium.svg";
import edgeIcon from "../images/ml2.0/browsers/edge.svg";
import electonIcon from "../images/ml2.0/browsers/electron.svg";
import firefoxNightlyIcon from "../images/ml2.0/browsers/firefox-nightly.svg";
import firefoxIcon from "../images/ml2.0/browsers/firefox.svg";
import ieIcon from "../images/ml2.0/browsers/ie.svg";
import mobileIcon from "../images/ml2.0/browsers/mobile.svg";
import operaIcon from "../images/ml2.0/browsers/opera.svg";
import safariIcon from "../images/ml2.0/browsers/safari.svg";
import webkitIcon from "../images/ml2.0/browsers/webkit.svg";
import yandexIcon from "../images/ml2.0/browsers/yandex.svg";
import cypressIcon from "../images/ml2.0/cypress.svg";
import hypertestIcon from "../images/ml2.0/hypertest.svg";
import k6Icon from "../images/ml2.0/k6.svg";
import linuxIcon from "../images/ml2.0/os/Linux.svg";
import androidIcon from "../images/ml2.0/os/android.svg";
import fireOsIcon from "../images/ml2.0/os/fireos.svg";
import appleIcon from "../images/ml2.0/os/ios.svg";
import windowsIcon from "../images/ml2.0/os/windows.svg";
import playwrightIcon from "../images/ml2.0/playwright.svg";
import puppeteerIcon from "../images/ml2.0/puppeteer.svg";
import seleniumIcon from "../images/ml2.0/selenium.svg";
import taikoIcon from "../images/ml2.0/taiko.svg";
import { TestStatusMap } from "../common/filterOptions";

const NOT_COMPLETED_TEST_STATUS_VALUES = [
  "Allocating VM",
  "queued",
  "running",
  "pqueued",
  "Cancelled"
];

const PLAYWRIGHT_BROWSERS = ["pw-chromium", "pw-firefox", "pw-webkit"];

export const dateFormat = (date, showMonthInWords = false) => {
  if (!date) {
    return null;
  }

  const day = new Date(date);

  const dd = day.getDate() < 10 ? `0${day.getDate()}` : `${day.getDate()}`;
  const mm =
    day.getMonth() + 1 < 10
      ? `0${day.getMonth() + 1}`
      : `${day.getMonth() + 1}`; //January is 0!
  const yyyy = day.getFullYear();

  if (showMonthInWords) {
    const lastTwoDigitsOfYear = yyyy.toString().slice(-2);
    return `${dd} ${moment()
      .month(mm - 1)
      .format("MMM")} ${lastTwoDigitsOfYear}`;
  }

  return `${mm}/${dd}/${yyyy}`;
};

export const timeFormat = date => {
  if (!date) {
    return `-`;
  }

  const day = new Date(date);
  return day.toTimeString().split(" ")[0];
};

export const timeDifference = (startDate, endDate, buildPane = false) => {
  if (!startDate || !endDate) {
    return `-`;
  }
  const diff =
    (new Date(endDate).getTime() - new Date(startDate).getTime()) / 1000;
  const date = new Date(null);
  date.setSeconds(diff); // specify value for SECONDS here
  if (buildPane) {
    return diff;
  }
  return date.toISOString().substr(11, 8);
};

export const timeSince = (
  date,
  currentDate = null,
  secondsOnly = false,
  buildView = false
) => {
  var createdDate = new Date(date).getTime() / 1000;
  var seconds = Math.floor(new Date().getTime() / 1000 - createdDate),
    interval = Math.floor(seconds / 31536000);
  if (secondsOnly) {
    return seconds;
  }
  if (interval > 1) return interval + " years ago";

  interval = Math.floor(seconds / 2592000);
  if (interval > 1) return interval + " months ago";

  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    if (interval === 1) {
      return interval + " day ago";
    }
    if (buildView) {
      let readableFormat = new Date(date);
      let dateReadableFormat = readableFormat.toDateString();
      let timeReadableFormat = readableFormat.toLocaleTimeString();
      // readableFormat.toFormat("MMM dd");
      return `${dateReadableFormat} at ${tConv24(timeReadableFormat)}`;
    } else {
      return interval + " days ago";
    }
  }

  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    if (interval === 1) {
      return interval + " hour ago";
    }
    return interval + " hours ago";
  }

  interval = Math.floor(seconds / 60);
  if (interval > 1) return interval + " minutes ago";

  return Math.floor(seconds) + " seconds ago";
};
///============ Convert 24 Hour Time to 12 Hour Time =============////////////
function tConv24(time24) {
  var ts = time24;
  var H = +ts.substr(0, 2);
  var h = H % 12 || 12;
  h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
  var ampm = H < 12 ? " AM" : " PM";
  ts = h + ts.substr(2, 3) + ampm;
  return ts;
}

/*  
    created - 13/Oct/2018@13:40
    Get Browser Icon By Browser Name
*/
export const getBrowserIconName = browserName => {
  browserName = browserName ? browserName.toLowerCase() : null;

  switch (browserName) {
    case "chrome":
      return "google_chrome.png";
    case "firefox":
      return "mozilla-firefox.png";
    case "maxthon":
      return "mozilla-firefox.png";
    case "internet explorer":
      return "ie.png";
    case "microsoftedge":
      return "edge.png";
    case "safari":
      return "safari.png";
    case "microsoftedgeinsider":
      return "microsoft-edge-insider.png";
    case "opera":
      return "opera-coloured.png";
    case "mobile":
      return "mobile.svg";
    default:
      return "browser.svg";
  }
};

export const getBrowserIcon = browserName => {
  browserName = browserName ? browserName.toLowerCase() : null;
  if (browserName === MOBILE) {
    return mobileIcon;
  } else if (browserName?.indexOf(CHROME) !== -1) {
    return chromeIcon;
  } else if (browserName?.indexOf(PW_CHROMIUM) !== -1) {
    return chromiumIcon;
  } else if (browserName?.indexOf(PW_FIREFOX) !== -1) {
    return firefoxNightlyIcon;
  } else if (browserName?.indexOf(FIREFOX) !== -1) {
    return firefoxIcon;
  } else if (browserName?.indexOf(SAFARI) !== -1) {
    return safariIcon;
  } else if (browserName?.indexOf(INTERNET_EXPLORER) !== -1) {
    return ieIcon;
  } else if (browserName?.indexOf(EDGE) !== -1) {
    return edgeIcon;
  } else if (browserName?.indexOf(OPERA) !== -1) {
    return operaIcon;
  } else if (
    browserName?.indexOf(PW_WEBKIT) !== -1 ||
    browserName?.indexOf(WEBKIT) !== -1
  ) {
    return webkitIcon;
  } else if (browserName?.indexOf(YANDEX) !== -1) {
    return yandexIcon;
  } else if (browserName?.indexOf(ELECTRON) !== -1) {
    return electonIcon;
  } else if (browserName?.indexOf(COMET) !== -1) {
    return cometIcon;
  } else {
    return defaultBrowserIcon;
  }
};

export const getOsIcon = osName => {
  const os = osName ? osName.toLowerCase() : null;
  if (!os) {
    return null;
  }
  if (os.indexOf("windows") !== -1) {
    return windowsIcon;
  } else if (
    os.indexOf("mac") !== -1 ||
    os.indexOf("macos") !== -1 ||
    os.indexOf("ios") !== -1
  ) {
    return appleIcon;
  } else if (os.indexOf("android") !== -1) {
    return androidIcon;
  } else if (os.indexOf("fireos") !== -1) {
    return fireOsIcon;
  } else if (os.indexOf("linux") !== -1 || os.indexOf("ubuntu") !== -1) {
    return linuxIcon;
  } else {
    return null;
  }
};

export const getBuildTypeImage = type => {
  let buildTypeImg;
  let buildTypeName = "";

  if (type?.includes("hypertest")) {
    buildTypeImg = hypertestIcon;
    buildTypeName = "HyperExecute";
  } else {
    switch (type) {
      case "selenium":
        buildTypeImg = seleniumIcon;
        buildTypeName = "Selenium";
        break;
      case "cypress":
        buildTypeImg = cypressIcon;
        buildTypeName = "Cypress";
        break;
      case "taiko":
        buildTypeImg = taikoIcon;
        buildTypeName = "Taiko";
        break;
      case "puppeteer":
        buildTypeImg = puppeteerIcon;
        buildTypeName = "Puppeteer";
        break;
      case "playwright":
        buildTypeImg = playwrightIcon;
        buildTypeName = "Playwright";
        break;
      case "k6":
        buildTypeImg = k6Icon;
        buildTypeName = "K6";
        break;
      case "appium":
        buildTypeImg = appiumIcon;
        buildTypeName = "Appium";
        break;
      default:
    }
  }

  return { buildTypeImg, buildTypeName };
};

/*
  created - 13/10/2018@15:30
  Summary Calculation On Build Pane
*/
export const calculateSummary = data => {
  let testCount = data.tests;
  let timeTaken = data.seconds ? convertTimeTaken(data.seconds) : 0;
  let passedTest = data.passed ? data.passed : 0;
  let failedTest = data.failed ? data.failed : 0;
  let othersTest = data.others ? data.others : 0;
  let string = "";

  if (parseInt(passedTest) !== 0) {
    string += ` ${passedTest} Passed`;
  }
  if (parseInt(failedTest) !== 0) {
    string += ` ${failedTest} Failed`;
  }
  if (parseInt(othersTest) !== 0) {
    string += ` ${othersTest} Others`;
  }
  // if (string) {
  return testCount + " Tests ran in " + timeTaken;
  // }
};
export const calculateTestSummary = data => {
  let username = data.tester;
  let date = dateFormat(data.createdAt);
  let from_time = data.startedAt;
  let to_time = data.endedAt;

  let string = `Started by ${username} on ${date} from ${from_time} ${
    to_time ? `to ${to_time}` : ""
  }`;
  return string;
};

export const convertTimeTaken = (
  seconds,
  milliseconds = false,
  shouldRoundOffToFloor = false
) => {
  if (milliseconds) {
    if (seconds < 1000) {
      return `${seconds}ms`;
    }
    seconds = seconds / 1000;
  }

  let a, b, days, x;

  if (seconds < 3600) {
    a = Math.floor(seconds / 60); //minutes
    b = seconds % 60; //seconds
    days = 0;

    if (!a) {
      return shouldRoundOffToFloor ? `${Math.floor(b)}s` : `${b.toFixed(0)}s`;
    }
    b = shouldRoundOffToFloor
      ? Math.floor(Math.round(b * 1000) / 1000)
      : Math.round(Math.round(b * 1000) / 1000);

    // in case value post roundoff comes out to be 60, add 1 to minutes
    if (b >= 60) {
      a += Math.floor(b / 60);
      b = b % 60;
    }

    // Handle rounding edge case for minutes (a >= 60)
    if (a >= 60) {
      const hours = Math.floor(a / 60);
      a = a % 60;
      return `${hours}h ${a}m`;
    }

    return `${a}m ${b}s`;
  } else {
    a = Math.floor(seconds / 3600); //hours
    x = seconds % 3600;
    b = Math.floor(x / 60); //minutes

    if (Number.isNaN(a) || Number.isNaN(b)) {
      return false;
    }

    if (a > 24) {
      days = Math.floor(a / 24);
      a = a % 24;
      if ((days = 1)) return `${days}day ${a}h ${b}m`;
      return `${days}days ${a}h ${b}m`;
    }

    return `${a}h ${b}m`;
  }
};

export const convertToMilliseconds = (
  time,
  startTime,
  areTimestampsInMilliseconds = false,
  isStartTimeAccurate = false,
  isFractionSeconds = false
) => {
  if (!time || !startTime) {
    return null;
  }
  if (areTimestampsInMilliseconds) {
    if (isStartTimeAccurate) {
      return startTime > time ? 0 : time - startTime;
    } else {
      return Math.max(time, startTime) - Math.min(time, startTime);
    }
  } else {
    /* Will have to convert the difference from nanoseconds to milliseconds */
    if (isStartTimeAccurate) {
      return startTime > time
        ? 0 // Timestamp for all the commands coming before video recording starts will be considered as 00:00:00
        : isFractionSeconds
        ? (time - startTime) / 1000000
        : Math.round((time - startTime) / 1000000000) * 1000; // to round off to nearest thousandth integer
    } else {
      return (Math.max(time, startTime) - Math.min(time, startTime)) / 1000000;
    }
  }
};

export const getGlobalBuildStatus = data => {
  let passed = 0;
  let test_count = data?.length;
  data.map((item, index) => {
    if ((item.status = "passed")) {
      passed += 1;
    }
    return passed;
  });
  if (passed === test_count) {
    return "Completed";
  } else {
    return "Pending";
  }
};

export const getDeviceSpecsInfo = (
  testDetail,
  showDuration = false,
  showResolution = false,
  showStartTime = false
) => {
  let specsInfo = [];
  if (!testDetail) {
    return specsInfo;
  }
  const testInfo = get(buildEnvironmentInfo(testDetail), "data", null);
  if (testInfo) {
    if (testInfo.type === "mobile") {
      specsInfo = [
        {
          label: "Device",
          value: testInfo.device_name
        },
        {
          label: "OS",
          value: `${capitalize(testDetail.category)} ${testInfo.os}`
        }
      ];
    } else {
      specsInfo = [
        {
          label: "Browser",
          value: `${testInfo.browser} ${testInfo.browser_version}`
        },
        {
          label: "OS",
          value: testInfo.os
        }
      ];
    }
    if (showResolution && testInfo.type !== "mobile") {
      specsInfo.push({
        label: "Resolution",
        value: testInfo.screen_resolution
      });
    }
    if (showDuration) {
      specsInfo.push({
        label: "Duration",
        value:
          testDetail.startedAt &&
          testDetail.endedAt &&
          !NOT_COMPLETED_TEST_STATUS_VALUES.includes(testDetail.status)
            ? convertTimeTaken(
                timeDifference(testDetail.startedAt, testDetail.endedAt, true)
              )
            : "N/A"
      });
    }
    if (showStartTime) {
      specsInfo.push({
        label: "Start at",
        value: testDetail.startedAt
      });
    }
  }
  return specsInfo;
};

export const isPlaywrightBrowser = browser => {
  return PLAYWRIGHT_BROWSERS.findIndex(element => element === browser) !== -1;
};

export const isIosPlaywrightTest = testDetails => {
  const isPlaywright = testDetails.type === TestTypes.PLAYWRIGHT;
  const isIos = testDetails.category === TestCategories.IOS;
  return isPlaywright && isIos;
};

/*  

    Build Environment Data Array 
    In order to Integrate 
    Environment Info Component 
*/
export const buildEnvironmentInfo = (env, testDetails = null) => {
  if (testDetails) {
    let envinfo = buildNewEnvInfo(env);
    return envinfo;
  }
  let os_type = env.category;

  let envInfo = {};

  switch (os_type) {
    case "windows":
      envInfo = {
        visible: true,
        data: {
          type: "pc",
          os: capitalize(env.osName),
          os_version: env.osVersion ? env.osVersion : "10",
          os_icon: "windows.png",
          device_name: "Desktop",
          screen_resolution: env.resolution ? env.resolution : "N/A",
          browser: env.browser
            ? isPlaywrightBrowser(env.browser)
              ? env.browser
              : capitalize(env.browser)
            : "N/A",
          browser_version: env.version,
          browser_icon: getBrowserIconName(env.browser),
          className: "envinfo",
          device_icon: "computer.png"
        }
      };
      return envInfo;
    case "android":
    case "Android":
      envInfo = {
        visible: true,
        data: {
          type: "mobile",
          os: capitalize(env.os) || env.osVersion,
          osName: capitalize(env.osName),
          os_version: env.osVersion,
          os_icon: env.report ? "mobile.png" : "mobile-small.svg",
          device_name: env.device.trim(),
          screen_resolution: env.resolution,
          browser: capitalize(env.browserName) || capitalize(env.browser),
          browser_version: env.version,
          browser_icon:
            getBrowserIconName(env.browser) ||
            getBrowserIconName(env.browserName),
          className: "envinfo",
          device_icon: "android-small.svg"
        }
      };
      return envInfo;

    case "fireos":
    case "FireOs":
      envInfo = {
        visible: true,
        data: {
          type: "mobile",
          os: capitalize(env.os) || env.osVersion,
          osName: capitalize(env.osName),
          os_version: env.osVersion,
          os_icon: env.report ? "mobile.png" : "mobile-small.svg",
          device_name: env.device.trim(),
          screen_resolution: env.resolution,
          browser: capitalize(env.browserName) || capitalize(env.browser),
          browser_version: env.version,
          browser_icon:
            getBrowserIconName(env.browser) ||
            getBrowserIconName(env.browserName),
          className: "envinfo",
          device_icon: "android-small.svg"
        }
      };
      return envInfo;

    case "mac":
      envInfo = {
        visible: true,
        data: {
          type: "pc",
          os: capitalize(env.osName),
          os_version: env.osVersion ? env.osVersion : "10",
          os_icon: env.report ? "apple.png" : "apple.svg",
          device_name: "Desktop",
          screen_resolution: env.resolution ? env.resolution : null,
          browser: env.browser
            ? isPlaywrightBrowser(env.browser)
              ? env.browser
              : capitalize(env.browser)
            : "N/A",
          browser_version: env.version,
          browser_icon: getBrowserIconName(env.browser),
          className: "envinfo",
          device_icon: "computer.png"
        }
      };
      return envInfo;
    case "ios":
    case "Ios":
    case "IOS":
      envInfo = {
        visible: true,
        data: {
          type: "mobile",
          os: capitalize(env.os) || env.osVersion,
          os_version: env.osVersion,
          os_icon: env.report ? "mobile.png" : "mobile.svg",
          device_name: env.device.trim(),
          screen_resolution: env.resolution,
          browser: capitalize(env.browserName) || capitalize(env.browser),
          browser_version: env.version,
          browser_icon:
            getBrowserIconName(env.browser) ||
            getBrowserIconName(env.browserName),
          className: "envinfo",
          device_icon: env.report ? "apple.png" : "ios.svg"
        }
      };
      return envInfo;
    case "linux":
      envInfo = {
        visible: true,
        data: {
          type: "pc",
          os: capitalize(env.osName),
          os_version: env.osVersion || "10",
          os_icon: "Linux.svg",
          device_name: "Desktop",
          screen_resolution: env.resolution || "N/A",
          browser: env.browser ? capitalize(env.browser) : "N/A",
          browser_version: env.version,
          browser_icon: getBrowserIconName(env.browser),
          className: "envinfo",
          device_icon: "computer.png"
        }
      };
      return envInfo;
    default:
      break;
  }
};

export const buildNewEnvInfo = env => {
  let envInfo = {};
  let os = env.OsVersion.category;
  if (os === `windows`) {
    envInfo = {
      visible: true,
      data: {
        type: "pc",
        os: capitalize(env.OsVersion.name),
        os_version: env.OsVersion.version,
        os_icon: "windows.png",
        device_name: "Desktop",
        screen_resolution: env.resolution,
        browser: capitalize(env.browser),
        browser_version: env.version,
        browser_icon: getBrowserIconName(env.browser),
        className: "envinfo",
        device_icon: "computer.png"
      }
    };
  } else {
    envInfo = {
      visible: true,
      data: {
        type: "pc",
        os: capitalize(env.OsVersion.name),
        os_version: env.OsVersion.version,
        os_icon: "apple.png",
        device_name: capitalize("macintosh"),
        screen_resolution: env.resolution,
        browser: capitalize(env.browser),
        browser_version: env.version,
        browser_icon: getBrowserIconName(env.browser),
        className: "envinfo",
        device_icon: "computer.png"
      }
    };
  }
  return envInfo;
};

export const extractTimeFromDateTimestamp = timestamp => {
  //let splittedTime = timestamp.split(" ");
  let splittedTime = [];
  return splittedTime[1] ? splittedTime[1] : "00:00:00";
};

export const formatBytes = bytes => {
  const decimals = 2;
  if (bytes === 0 || bytes === -1) return "0";
  const k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const buildAnalyticsCounterData = (data, type) => {
  let result = [];
  let typename = null;
  switch (type) {
    case "build":
      typename = "Builds";
      break;
    case "test":
      typename = "Tests";
      break;

    default:
      break;
  }
  for (var property in data) {
    if (data.hasOwnProperty(property)) {
      let counterContent = {};
      switch (property) {
        case "builds":
          counterContent = {
            text: `Total ${typename} Run`,
            count: data[property] ? data[property] : 0
          };
          result.push(counterContent);
          break;
        case "tests":
          counterContent = {
            text: `Total ${typename} Run`,
            count: data[property] ? data[property] : 0
          };
          result.push(counterContent);
          break;
        case "minutes":
          counterContent = {
            text: "Minutes Consumed",
            count: data[property] ? data[property] : 0
          };
          result.push(counterContent);
          break;
        case "seconds":
          counterContent = {
            text: "Minutes Consumed",
            count: data[property] ? (data[property] / 60).toFixed(0) : "0"
          };
          result.push(counterContent);
          break;
        case "passed":
          counterContent = {
            text: `${typename}  Passed`,
            count: data[property] ? data[property] : 0
          };
          result.push(counterContent);
          break;
        case "failed":
          counterContent = {
            text: `${typename}  Failed`,
            count: data[property] ? data[property] : 0
          };
          result.push(counterContent);
          break;
        case "issues":
          counterContent = {
            text: "Total Bugs Logged",
            count: data[property] ? data[property] : 0
          };

          result.push(counterContent);
          break;
        case "errorCount":
          counterContent = {
            text: `${typename} Error`,
            count: data[property] ? data[property] : 0
          };

          result.push(counterContent);
          break;
        case "timeout":
          counterContent = {
            text: `${typename} Timeout`,
            count: data[property] ? data[property] : 0
          };

          result.push(counterContent);
          break;
        default:
          break;
      }
    }
  }
  return result;
};

export const validateQueryString = (url, field) => {
  if (url.indexOf("?" + field + "=") !== -1) return true;
  else if (url.indexOf("&" + field + "=") !== -1) return true;
  return false;
};

export const parseJwt = token => {
  //var base64Url = token.split(".")[1];

  // if(token[1]){
  //   base64Url = token[1].split(".")[1];
  // }
  let base64Url = token.split(".")[1];
  if (base64Url) {
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64) || "{}");
  }
  return false;
};

export const createHash = token => {
  let hash = token.split("&");
  //  hash = hash.length > 1 ? hash[1] : null;

  return hash;
};

export const getCookieValue = cookie_val => {
  var value = document.cookie.match(
    "(^|;)\\s*" + cookie_val + "\\s*=\\s*([^;]+)"
  );
  value = value ? value.pop() : "";
  if (value) {
    value = value.split("&");
    value = value[0];
  }
  return value;
};

export const getFirstName = name => {
  if (name) {
    let name_arr = name.split(" ");
    return name_arr[0];
  } else {
    return "James";
  }
};

export const deleteCookie = name => {
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const getKey = (obj, val) =>
  Object.keys(obj).find(key => obj[key] === val);

export const deriveAction = action => {
  let session_key = getKey(action, "session");
  let result = [];
  action.map((item, index) => {
    // push all items to result array when session key is not present
    if (!session_key) {
      result.push(item);
    } else if (index > session_key) {
      result.push(item);
    }
    return true;
  });

  let result_string = null;
  if (result?.length > 0) {
    if (result?.length >= 3) {
      let id = result[2].split("-");
      result_string = `${result[1]}/${result[2]}`;
      if (result[3]) {
        result_string = `${result[1]}/${result[2]}/${result[3]}`;
      }
    } else {
      if (result?.length === 2) {
        result_string = result[1];
      } else {
        // for cases where session_id is not present in the action
        if (!session_key && result?.length === 1) {
          result_string = result[0];
        } else {
          result_string = null;
        }
      }
    }
  } else {
    result_string = null;
  }
  return result_string;
};

export const filterApiData = filter => {
  let filterBy = "week";
  let filterparams = [];
  filter.map(item => {
    if (item) {
      if (item["username"] && item["username"]?.length > 0) {
        filterparams.push(`username=${item.username}`);
      }
      if (item["browser"] && item["browser"]?.length > 0) {
        filterparams.push(`browser=${item.browser}`);
      }
      if (item["os"] && item["os"]?.length > 0) {
        filterparams.push(`os=${item.os}`);
      }
      if (item["daterange"] && item["daterange"]?.length > 0) {
        filterBy = `range`;
        filterparams.push(`range=${item.daterange}`);
      }
      if (item["chrono"] && item["chrono"]?.length > 0) {
        filterBy = `${item.chrono}`;
      }
      if (item["build"] && item["build"]?.length > 0) {
        filterparams.push(`build=${item.build}`);
      }
      if (item["status"] && item["status"]?.length > 0) {
        filterparams.push(`status=${item.status}`);
      }
      if (item["date"] && item["date"]?.length > 0) {
        filterparams.push(`date=${item.date}`);
      }
    }
    return true;
  });
  return { filterBy: filterBy, filterparams: filterparams };
};

export const globalFilterHandler = data => {
  let usernames = {};
  let builds = {};
  let date = {};
  let status_val = {};

  /*
    Set Data According to Filter
  */
  let filterData = data[0] ? data[0] : [];
  if (filterData) {
    switch (filterData.type) {
      case "username":
        if (filterData.value) {
          usernames = { filter_username: filterData.value };
        } else {
          usernames = { filter_username: null };
        }
        break;
      case "build":
        if (filterData.value) {
          builds = { filter_build: filterData.value };
        } else {
          builds = { filter_build: null };
        }
        break;
      case "status":
        if (filterData.value) {
          status_val = { filter_status: filterData.value };
        } else {
          status_val = { filter_status: filterData.value };
        }
        break;
      case "date":
        if (filterData.value) {
          date = { filter_date: filterData.value };
        } else {
          date = { filter_date: null };
        }
        break;

      default:
        usernames = {};
        builds = {};
        date = {};
        status_val = {};
        break;
    }

    /*
    Build Filters According to Global Set.
  */
    let filter = [];
    let filter_username = usernames.filter_username
      ? usernames.filter_username
      : null;
    let filter_build = builds.filter_build ? builds.filter_build : null;
    let filter_status = status_val.filter_status
      ? status_val.filter_status
      : null;
    let filter_date = date.filter_date ? date.filter_date : null;

    filter.push(
      { username: filter_username },
      { build: filter_build },
      { status: filter_status },
      { date: filter_date }
    );

    return filter;
  }
};

export const checkMinimal = (minimal, endPoint) => {
  if (minimal) {
    endPoint = `${endPoint}&minimal=true`;
  }
  return endPoint;
};

export const calculatePages = total => {
  let pages =
    parseInt(total) / parseInt(process.env.REACT_APP_DEFAULT_PAGE_LENGTH);
  pages = Math.ceil(pages);
  return pages;
};

export const timeConverter = UNIX_timestamp => {
  var a = new Date(UNIX_timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =
    date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
  return time;
};

export const getQueryStringValue = key => {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );
};

export const removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split("?");
  if (urlparts?.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars?.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = urlparts[0] + "?" + pars.join("&");
    return url;
  } else {
    return url;
  }
};

export const updateURLParameter = (url, param, paramVal) => {
  var TheAnchor = null;
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";

  if (additionalURL) {
    var tmpAnchor = additionalURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if (TheAnchor) additionalURL = TheParams;

    tempArray = additionalURL.split("&");

    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split("=")[0] !== param) {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  } else {
    tmpAnchor = baseURL.split("#");
    TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];

    if (TheParams) baseURL = TheParams;
  }

  if (TheAnchor) paramVal += "#" + TheAnchor;

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
};

export const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const summarizeBuildStatus = buildInfo => {
  let statusObj = {
    status: null,
    class: null
  };
  let errorCount =
    parseInt(buildInfo.error) +
    parseInt(buildInfo.lambdaError) +
    parseInt(buildInfo.timeout) +
    parseInt(buildInfo.failed);
  if (
    buildInfo &&
    buildInfo.tests &&
    buildInfo.passed &&
    parseInt(buildInfo.error) === 0 &&
    parseInt(buildInfo.lambdaError) === 0 &&
    parseInt(buildInfo.timeout) === 0 &&
    parseInt(buildInfo.failed) === 0 &&
    parseInt(buildInfo.passed) === parseInt(buildInfo.tests)
  ) {
    statusObj.status = `Passed`;
    statusObj.class = `passed`;
  }
  if (
    buildInfo &&
    buildInfo.tests &&
    buildInfo.failed &&
    parseInt(buildInfo.failed) === parseInt(buildInfo.tests)
  ) {
    statusObj.status = `Failed`;
    statusObj.class = `failed`;
  }
  if (
    buildInfo &&
    buildInfo.tests &&
    buildInfo.completed &&
    parseInt(buildInfo.completed) === parseInt(buildInfo.tests)
  ) {
    statusObj.status = `Completed`;
    statusObj.class = `passed`;
  }

  if (
    buildInfo &&
    buildInfo.tests &&
    errorCount > 0 &&
    (parseInt(buildInfo.completed) !== parseInt(buildInfo.tests) ||
      parseInt(buildInfo.passed) !== parseInt(buildInfo.tests))
  ) {
    statusObj.status = `${errorCount} Errors`;
    statusObj.class = `initiated`;
  }

  if (
    buildInfo &&
    buildInfo.tests &&
    !statusObj.status &&
    buildInfo.stopped > 0 &&
    (parseInt(buildInfo.completed) !== parseInt(buildInfo.tests) ||
      parseInt(buildInfo.passed) !== parseInt(buildInfo.tests))
  ) {
    statusObj.status = `${buildInfo.stopped} Stopped`;
    statusObj.class = `initiated`;
  }

  return statusObj;
};

export const pluralize = (word, factor) => {
  if (parseInt(factor) > 1) {
    word = `${word}s`;
  }
  return word;
};

export const timeTo12HrFormat = time => {
  // Take a time in 24 hour format and format it in 12 hour format
  var time_part_array = time.split(":");
  var ampm = "AM";

  if (time_part_array[0] >= 12) {
    ampm = "PM";
  }

  if (time_part_array[0] > 12) {
    time_part_array[0] = time_part_array[0] - 12;
  }

  let formatted_time = time_part_array[0] + " " + ampm;

  return formatted_time;
};

export const getMinutesDifference = (timeEnded, currentTime) => {
  let timeDifference = currentTime - timeEnded;
  let minutes = timeDifference / 60 / 1000;
  minutes = minutes ? minutes.toFixed(0) : minutes;
  return minutes;
};

export const checkTimeLimit = val => {
  let dayflag = true;
  if (val[0] == "-") return false;
  for (let i = 0; i < val.length - 4; i++) {
    if (val[i] == "d" && val[i + 1] == "a" && val[i + 2] == "y") {
      let daysCount = parseInt(val.slice(0, i));
      dayflag = false;
      if (daysCount > 0) return false;
    }
  }
  if (dayflag) {
    for (let i = 0; i < val.length; i++) {
      if (val[i] == "h") {
        let hoursCount = parseInt(val.slice(0, i));
        if (hoursCount > 10) return false;
      }
    }
  }
  return true;
};
export const getBuildStatus = item => {
  let status = "completed";
  if (parseInt(item.running) > 0) {
    status = "running";
  } else if (parseInt(item.failed) > 0) {
    status = "failed";
  } else if (parseInt(item.error) > 0) {
    status = "error";
  } else if (item.queued > 0 || item.pqueued > 0) {
    status = "queued";
  } else if (
    parseInt(item.completed) === parseInt(item.tests) ||
    parseInt(item.passed) === parseInt(item.tests)
  ) {
    status = "completed";
  } else if (item.stopped > 0) {
    status = "stopped";
  }
  return status;
};

export const getPlateformIcon = plateformName => {
  plateformName = plateformName ? plateformName.toLowerCase() : null;
  if (!plateformName) {
    return null;
  }
  if (plateformName?.indexOf("win") !== -1) {
    return "windows.svg";
  } else if (plateformName === "mobile") {
    return "mobile.svg";
  } else {
    return "macos.svg";
  }
};

export const getBrowserNameBS = browserNameLT => {
  switch (browserNameLT) {
    case "Internet Explorer":
      return "IE";
    case "MicrosoftEdge":
      return "Edge";
    default:
      return browserNameLT;
  }
};
export const getPlateformNameBS = platformNameLT => {
  let platform = platformNameLT.substr(0, platformNameLT.indexOf(" "));
  let platformVersion = platformNameLT.substr(platformNameLT.indexOf(" ") + 1);
  if (platformNameLT?.toLowerCase().indexOf("mac") !== -1) {
    platform = "OS X";
  }
  if (platformNameLT?.toLowerCase().indexOf("os x") !== -1) {
    platform = "OS X";
    platformVersion = platformNameLT.substr(platformNameLT.indexOf(" ") + 3);
  }
  return {
    platform,
    platformVersion
  };
};

export const getAppiumCapabilitiesCode = (cap, type, n, i) => {
  if (!cap) {
    return "";
  }
  // appiumversion and platformversion might be enabled in future release, currently not supported
  const parameters = Object.keys(cap).filter(
    item =>
      item !== "brand" && item !== "appiumVersion" && item !== "platformVersion"
  );
  const capabilityArr = [];
  let spaces = "";
  while (n-- > 0) spaces += " ";
  switch (type) {
    case "java": {
      parameters.forEach(param =>
        capabilityArr.push(
          `capabilities.setCapability("${param}", "${cap[param]}");`
        )
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "javaParallel": {
      parameters.forEach(param =>
        capabilityArr.push(`capsHashtable.put("${param}", "${cap[param]}");`)
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "js": {
      parameters.forEach(param =>
        capabilityArr.push(`${param}: "${cap[param]}"`)
      );
      return capabilityArr.join(`,\n${spaces}`);
    }
    case "js2": {
      parameters.forEach(param =>
        capabilityArr.push(`"${param}": "${cap[param]}"`)
      );
      return capabilityArr.join(`,\n${spaces}`);
    }
    case "nunit": {
      parameters.forEach(param => capabilityArr.push(`"${cap[param]}"`));
      return capabilityArr.join(`, `);
    }
    case "php": {
      parameters.forEach(param =>
        capabilityArr.push(`"${param}" => "${cap[param]}"`)
      );
      return capabilityArr.join(`,\n${spaces}`);
    }
    case "behat": {
      parameters.forEach(param =>
        capabilityArr.push(`${param}: ${cap[param]}`)
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "codeception": {
      parameters.forEach(param =>
        capabilityArr.push(`${param}: '${cap[param]}'`)
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "robot": {
      parameters.forEach(param =>
        capabilityArr.push(`--variable ${param}:"${cap[param]}"`)
      );
      return capabilityArr.join(` `);
    }
    case "rubySingle": {
      parameters.forEach(param =>
        capabilityArr.push(`caps[:${param}] = '${cap[param]}'`)
      );
      return capabilityArr.join(`\n`);
    }
    case "rubyParallel": {
      parameters.forEach(param =>
        capabilityArr.push(`caps${i + 1}['${param}'] = '${cap[param]}'`)
      );
      return capabilityArr.join(`\n`);
    }
    case "test::unit": {
      parameters.forEach(param =>
        capabilityArr.push(`:${param} => "${cap[param]}"`)
      );
      return capabilityArr.join(`,\n${spaces}`);
    }
    case "testng": {
      parameters.forEach(param =>
        capabilityArr.push(`caps.setCapability("${param}", "${cap[param]}");`)
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "cucumber": {
      parameters.forEach(param =>
        capabilityArr.push(
          `<parameter name="${param}" value="${cap[param]}" />`
        )
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    case "serenitySingle": {
      parameters.forEach(param =>
        capabilityArr.push(`environment.single.${param}=${cap[param]}`)
      );
      return capabilityArr.join(`\n`);
    }
    case "serenityParallel": {
      parameters.forEach(param =>
        capabilityArr.push(
          `environment.parallel_${i + 1}.${param}=${cap[param]}`
        )
      );
      return capabilityArr.join(`\n`);
    }
    case "rspec": {
      parameters.forEach(param =>
        capabilityArr.push(`"${param}": "${cap[param]}"`)
      );
      return capabilityArr.join(`\n${spaces}`);
    }
    default:
      break;
  }

  return "";
};

export function sendAmplitudeEvents(eventName, data) {
  if (window.amplitude) {
    if (window.amplitude.track) {
      window.amplitude.track(eventName, {
        ...data,
        isNewTheme: true,
        page: window.location.href,
        isTestRenderedInDrawer: isRenderingInTestDrawerFlagEnabled(
          window.amplitudeData
        )
      });
    } else {
      window.amplitude.getInstance().logEvent(eventName, {
        ...data,
        isNewTheme: true,
        page: window.location.href,
        isTestRenderedInDrawer: isRenderingInTestDrawerFlagEnabled(
          window.amplitudeData
        )
      });
    }
  }
}

export function transformName(
  str,
  lengthOfStartingCharacters,
  numOfDots,
  lengthOfEndingCharacters
) {
  if (str?.length <= lengthOfStartingCharacters + lengthOfEndingCharacters) {
    return str;
  } else {
    let newStr = "";
    for (let i = 0; i < lengthOfStartingCharacters; i++) {
      newStr = newStr + str[i];
    }
    for (let i = 0; i < numOfDots; i++) {
      newStr = newStr + ".";
    }
    for (let i = str.length - lengthOfEndingCharacters; i < str.length; i++) {
      newStr = newStr + str[i];
    }
    return newStr;
  }
}

/*
 * Checks whether user ran tests in headless mode.
 * @param {!Object<string, *> parsedCapability Test capabilities
 * @return {bool} Whether headless mode was selected.
 */
export const isHeadlessMode = parsedCapability => {
  const desiredCapabilities =
    parsedCapability && parsedCapability.desiredCapabilities;

  if (desiredCapabilities) {
    const normalHeadlessCapability = desiredCapabilities.headless;

    const headlessInChrome = get(desiredCapabilities, "goog:chromeOptions", {});

    const headlessInFirefox = get(
      desiredCapabilities,
      "moz:firefoxOptions",
      {}
    );

    const headlessInEdge = get(desiredCapabilities, "ms:edgeOptions", {});

    const isHeadlessBrowserCapability = [
      headlessInChrome,
      headlessInFirefox,
      headlessInEdge
    ].some(
      capability =>
        capability.args && capability.args.find(value => /headless/.test(value))
    );

    return isHeadlessBrowserCapability || normalHeadlessCapability;
  } else {
    return false;
  }
};

export const isCDPTest = type => {
  return process.env.REACT_APP_CDP_TEST_TYPES.indexOf(type) !== -1;
};

export const isWasabiEnabledForCurrentOrg = ({ testDetails }) => {
  const { environment = {}, feature_flag = {}, type = "" } = testDetails;
  const isWasabiEnabled = get(feature_flag, "wasabiEnabled", false);
  if (
    (type === "selenium" || isCDPTest(type) || type === TestTypes.CYPRESS) &&
    // Remove Real Devices. This will be added in upcoming release.
    isWasabiEnabled
  ) {
    return true;
  }
  return false;
};

export const getDownloadParamsForMobileTest = ({
  isOrgInfoPresent,
  testDetail,
  urlParams
}) => {
  const testDate = testDetail.startedAt || testDetail.createdAt || null;
  const startDate = moment.utc(testDate).format("YYYY-MM-DD");
  if (
    testDetail &&
    (testDetail.category === "android" || testDetail.category === "ios")
  ) {
    const downloadQueryParams = `type=mobile&startDate=${startDate}`;
    // URL params are already added which contain ORG ID.
    if (isOrgInfoPresent) {
      urlParams += `&${downloadQueryParams}`;
    } else {
      urlParams = `?orgId=${testDetail.org_id}&${downloadQueryParams}`;
    }
    return urlParams;
  }
  let paramPrefix = "?";
  if (urlParams.includes("?")) {
    paramPrefix = "&";
  }
  urlParams += `${paramPrefix}testCreateTimestamp=${moment
    .utc(testDetail.createdAt)
    .format("YYYY-MM-DD HH:MM:SS")}&orgId=${
    testDetail.org_id
  }&startDate=${startDate}`;

  if (!testDetail.isRealMobile) {
    const featureFlags = testDetail?.feature_flag || {};
    const retentionDays = featureFlags?.retention_days;
    if (retentionDays) {
      urlParams += `&dataRetentionDays=${retentionDays}`;
    }
  }
  return urlParams;
};

export const isElementInViewport = elem => {
  if (elem) {
    const rect = elem.getBoundingClientRect();
    if (
      rect.x + rect.width < 0 ||
      rect.y + rect.height < 0 ||
      rect.x > window.innerWidth ||
      rect.y > window.innerHeight
    ) {
      return false;
    }
  }
  return true;
};

export const isRenderingInTestDrawerFlagEnabled = featureFlags => {
  return (
    get(featureFlags, ["ml_test_page_in_drawer", "variant", "key"], "false") ===
    "true"
  );
};

export const isNewCypressTestViewEnabled = featureFlags => {
  return (
    get(featureFlags, ["ml_new_cypress_test_view", "variant", "key"], "off") ===
    "on"
  );
};

export const isMp4VideoFlagEnabled = featureFlags => {
  const { ml_mp4_video_live_command_log } = featureFlags || {};

  return (
    (typeof ml_mp4_video_live_command_log === "boolean" &&
      ml_mp4_video_live_command_log) ||
    ml_mp4_video_live_command_log === "true"
  );
};

export const isPwAndroidLiveLogsEnabled = featureFlags => {
  const { pw_mobile_live_command_logs } = featureFlags || {};

  return (
    (typeof pw_mobile_live_command_logs === "boolean" &&
      pw_mobile_live_command_logs) ||
    pw_mobile_live_command_logs === "true"
  );
};

export const isHyperExecuteLiveLogsEnabled = testDetails => {
  return (
    testDetails?.type === TestTypes.SELENIUM &&
    testDetails?.mode === "hypertest"
  );
};

export const isVirtualDeviceMp4VideoFlagEnabled = featureFlags => {
  const { virtual_device_mp4_video } = featureFlags || {};

  return (
    (typeof virtual_device_mp4_video === "boolean" &&
      virtual_device_mp4_video) ||
    virtual_device_mp4_video === "true"
  );
};

export const isLtCentralizedProjectFlagEnabled = featureFlags => {
  return (
    get(
      featureFlags,
      ["lt_centralized_projects", "variant", "key"],
      "false"
    ) === "true"
  );
};

export const getOrgPath = (testDetails, useTwoDigitDayFormat = false) => {
  if (testDetails) {
    const testCreatedDate =
      get(testDetails, "createdAt", "") ||
      get(testDetails, ["environment", "createdAt"], "");
    const orgId =
      get(testDetails, "org_id", 0) ||
      get(testDetails, ["environment", "org_id"], 0);
    const dateFormat = useTwoDigitDayFormat ? "YYYY/MM/DD" : "YYYY/MM/D";
    const testDate = moment.utc(testCreatedDate).format(dateFormat);
    return `orgId-${orgId}/${testDate}`;
  }
  return "";
};

/*
 * @params callback -> method to be called if the click is detected outside
 * @params ref -> reference of the element
 * @params target -> target element to look for inside ref
 * @returns boolean describing whether click is detected outside or not
 */
export const handleClickOutside = (e, ref, callback = () => {}) => {
  if (ref && ref.current && !ref.current.contains(e.target)) {
    callback();
  }
};

/**
 * Computes domain suffix to be automatically attached to all the API requests being sent from FE.
 * @param {string} urlPrefix The prefix to be attached to the domains.
 * @param {string} urlProtocol The protocol to be attached to the domains.
 * @returns The API endpoint.
 */
export const getUrlByUserDomain = (
  urlPrefix,
  urlProtocol = "https",
  isHyperExecuteCloudDomain
) => {
  const origin = window.location.origin;
  const domainParts = origin.split(".");
  // Remove the first word from the domain as it is not needed.
  domainParts.shift();
  // Remove the first word again from the remaining list if it is a enterprise URL.
  // Sample URL: https://automation.infosys.lambdatestinternal.com
  if (
    (origin.includes("lambdatest") || origin.includes("hyperexecute.cloud")) &&
    getBrandName()
  ) {
    domainParts.shift();
  }
  if (isHyperExecuteCloudDomain && isHyperExecuteCloudDomain === "true") {
    const domainName = getLTDomainName();
    return `${urlProtocol}://${urlPrefix}${domainName}`;
  }
  const domainToAdd = `.${domainParts.join(".").split(":")[0]}`;
  return urlPrefix
    ? `${urlProtocol}://${urlPrefix}${domainToAdd}`
    : domainToAdd;
};

/**
 * Gets the domain to be appended based on the region of the URL.
 * @returns {string} The domain suffix
 */
function getLTDomainName() {
  const hostname = window.location.hostname;
  if (isStage()) {
    return ".lambdatestinternal.com";
  }
  return ".lambdatest.com";
}

export function isStage() {
  const hostname = window.location.hostname;
  return hostname?.startsWith("stage-") || hostname?.startsWith("dev.");
}

/**
 * Checks if the TMS Merger feature flag is enabled.
 * @returns {boolean} True if TMS Merger is enabled, false otherwise.
 */
export const isTmsMergerEnabled = () => {
  const featureFlags = window?.amplitudeData || {};
  const tmsMergerFlag = featureFlags?.tms_merger_enabled;
  return tmsMergerFlag?.variant?.key === "true";
};

/**
 * Gets the API base URL prefix with TMS Merger suffix if enabled.
 * @returns {string} The API base URL prefix (e.g., "stage-api" or "stage-api/tms-merger")
 */
export const getApiBaseUrlPrefix = () => {
  const basePrefix =
    process.env.REACT_APP_API_BASE_URL_PREFIX ||
    window?._env_?.REACT_APP_API_BASE_URL_PREFIX;

  if (isTmsMergerEnabled()) {
    return `${basePrefix}/tms-merger`;
  }

  return basePrefix;
};

/**
 * Gets the full API base URL with TMS Merger suffix if enabled.
 * @param {string} urlProtocol - The protocol to use (default: "https")
 * @param {string} isHyperExecuteCloudDomain - Whether this is a HyperExecute cloud domain
 * @param {boolean} excludeFromTmsMerger - Whether to skip adding the tms-merger suffix.
 *                                        Excluded APIs: LTMA (`/automation`), Insights (`/insights`).
 * @returns {string} The full API base URL
 */
export const getApiBaseUrl = (
  urlProtocol = "https",
  isHyperExecuteCloudDomain,
  excludeFromTmsMerger = false
) => {
  const baseUrl = getUrlByUserDomain(
    process.env.REACT_APP_API_BASE_URL_PREFIX ||
      window?._env_?.REACT_APP_API_BASE_URL_PREFIX,
    urlProtocol,
    isHyperExecuteCloudDomain
  );

  if (isTmsMergerEnabled() && !excludeFromTmsMerger) {
    return `${baseUrl}/tms-merger`;
  }

  return baseUrl;
};

/**
 * Computes the brand name from the url for branded domains to redirect to different products accordingly
 * TODO (garvitk): Currently this does not work with dev environment.
 * @returns The brand name
 */
export const getBrandName = () => {
  const origin = window.location.origin; // For eg: https://stage-automation-infosys.lambdatestinternal.com
  const regex = new RegExp(/automation/g);

  // Check URLs with more than 5 dots from brand generation logic and ignores them as these do not
  // follow brand name convention that we are following.
  // For example: https://hyperexecute-wf-automation.cluster005.aks-scus-p.k8s.wellsfargo.net
  if (origin.match(/\./g).length >= 5) {
    return "";
  }

  if (origin.split(regex)[1]) {
    const domainParts = origin.split(regex)[1].slice(1); // 'infosys.lambdatestinternal.com'
    const desiredDomainParts = domainParts.split("."); // ['infosys', 'lambdatestinternal', 'com']
    if (desiredDomainParts[0].includes("lambdatest")) {
      return null;
    }
    // Handles HyEx.cloud domain.
    if (
      desiredDomainParts?.length === 2 &&
      desiredDomainParts[0].includes("hyperexecute") &&
      desiredDomainParts[1].includes("cloud")
    ) {
      return null;
    }
    return desiredDomainParts[0];
  }
};

export const appendParamsToUrl = ({
  endPoint,
  mobile = undefined,
  orgId,
  testDetails,
  type = "",
  testType = "",
  automationLogsHost = null,
  areLogsFetchedFromLTMA = false,
  isCDP = false
}) => {
  const testCreatedTimestamp = moment(testDetails.createdAt).unix();
  const isWasabiEnabled = isWasabiEnabledForCurrentOrg({ testDetails });
  const { mode = "" } = testDetails;

  // for lambda fucntion - default is = desktop/s3/us
  let logsSource = process.env.REACT_APP_DEBUGGER_HOST_PREFIX;
  if (isWasabiEnabled) {
    logsSource = process.env.REACT_APP_WASABI_DEBUGGER_HOST_PREFIX;
    if (mobile && !isCDP) {
      logsSource = process.env.REACT_APP_MOBILE_WASABI_LOG_HOST;
    }
  } else {
    // s3
    if (mobile && !isCDP) {
      logsSource = process.env.REACT_APP_MOBILE_LOG_HOST;
    }
  }

  let baseUrl = areLogsFetchedFromLTMA
    ? `${getApiBaseUrl(
        "https",
        process.env.REACT_APP_HIDE_PUBLIC_LINKS
      )}/automation/api/v1/getLogs`
    : `${getUrlByUserDomain(
        logsSource,
        "https",
        process.env.REACT_APP_HIDE_PUBLIC_LINKS
      )}/getLogs`;

  let paramPrefix = "?";
  if (endPoint.includes("?")) {
    paramPrefix = "&";
  }
  if (isWasabiEnabled) {
    endPoint += `${paramPrefix}orgId=${orgId}&timestamp=${testCreatedTimestamp}&isWasabiEnabled=true&testCreateTimestamp=${testDetails.createdAt}`;
  } else {
    endPoint += `${paramPrefix}orgId=${orgId}&testCreateTimestamp=${testDetails.createdAt}`;
  }

  // Real Mobile Command Logs are fetched from a different place.
  if (
    type === "commandLogs" &&
    testType === "realMobile" &&
    !areLogsFetchedFromLTMA
  ) {
    baseUrl = `${getUrlByUserDomain(
      process.env.REACT_APP_REAL_MOBILE_DEBUGGER_HOST_PREFIX,
      "https",
      process.env.REACT_APP_HIDE_PUBLIC_LINKS
    )}/getLogs`;
  }

  if (testType === "realMobile" && areLogsFetchedFromLTMA) {
    endPoint += `&isRealMobile=true`;
  }
  // Use RD Endpoint for network logs for Android PW.
  const { category = "" } = testDetails;
  const isRealMobile = testDetails && testDetails.isRealMobile ? true : false;
  const isIosPlaywright = isIosPlaywrightTest(testDetails);

  if (
    type === "network" &&
    isCDP &&
    isRealMobile &&
    (category === TestCategories.ANDROID || isIosPlaywright)
  ) {
    endPoint += `&isRealMobile=1&mob=${category}&testType=mobile`;
  }
  if (automationLogsHost && mode === "hypertest" && !areLogsFetchedFromLTMA) {
    baseUrl = `${automationLogsHost}/getLogs`;
  }
  return {
    updatedApiClient: createRestApiClient().withConfig({
      baseURL: baseUrl
    }).client,
    updatedEndPoint: endPoint
  };
};

/**
 * This method is used to download selenium/appium, console and terminal logs
 */
export const downloadLogs = (logs, logType, testId) => {
  sendAmplitudeEvents(EventsMap.TEST_VIEW_DOWNLOAD_LOGS, {
    logsTab: logType
  });
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";

  let blob;
  let extension = "log";
  if (logType === LogsType.DEVICE_LOGS) {
    blob = new Blob([logs], { type: "application/zip" });
    extension = "zip";
  } else {
    //if logs is already a string, we don't need to stringify it again
    // stringify(logs, null, 4): pretty print the JSON with 4 spaces indentation for each level
    const formattedLogs =
      typeof logs === "string" ? logs : JSON.stringify(logs, null, 2);

    // Replace \n with actual newline characters
    let logsWithLineBreaks = formattedLogs.replace(/\\n/g, "\n");

    // Replace \t with actual tab characters.
    logsWithLineBreaks = formattedLogs.replace(/\\t/g, "\t");

    blob = new Blob([logsWithLineBreaks], {
      type: "octet/stream"
    });
  }
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.target = "__blank";
  a.download = `lambda-logs-${logType}-${testId}.${extension}`;
  a.click();
  window.URL.revokeObjectURL(url);
};

/*
 * This method is used to check whether any build filter is applied or not
 */

export const noBuildFilterApplied = timelineFilter => {
  const {
    status,
    project,
    username,
    buildType,
    tag,
    searchText,
    range,
    build,
    testTag
  } = timelineFilter;
  if (
    !status?.length &&
    !project?.length &&
    !username?.length &&
    !buildType?.length &&
    !tag?.length &&
    !searchText?.length &&
    !build?.length &&
    !range &&
    !testTag?.length
  ) {
    return true;
  }
  return false;
};

export const noTestFilterApplied = filter => {
  if (
    !filter?.os?.length &&
    !filter?.status?.length &&
    !filter?.project?.length &&
    !filter?.browser?.length &&
    !filter?.buildName?.length &&
    !filter?.build?.length &&
    !filter?.username?.length &&
    !filter?.type?.length &&
    !filter?.tag?.length &&
    !filter?.searchText?.length &&
    !filter?.range?.length &&
    !filter?.filterBy?.length &&
    !filter?.sortBy?.length &&
    !filter?.sortType?.length &&
    !filter?.resolution?.length
  ) {
    return true;
  }
  return false;
};

/**
 * Parses JSON string object. Returns an empty object incase parsing fails.
 * @param {string} jsonString
 * @returns
 */
export function gracefullyParseJSON(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return {};
  }
}

export function isSharingRoute() {
  const pathname = window.location.pathname;
  return pathname === '/share' ||
    pathname === '/share/playwright-trace' ||
    pathname === '/share/lighthouse-report' ||
    pathname.indexOf('/share/') !== -1;
}

/** Extracts shareId from the URL — checks path segment (/share/{id}) first, then query param (?shareId=). */
export function getShareId() {
  try {
    const parts = window.location.pathname.split('/share/');
    const fromPath = parts[1]?.split('/')[0]?.split('?')[0] || '';
    if (fromPath) {
      return fromPath;
    }
    return new URLSearchParams(window.location.search).get('shareId') || '';
  } catch {
    return '';
  }
}

export function generateFtdDateRange() {
  const endDate = `${moment().format("YYYY-MM-DD")} 23:59:59`;
  const startDate = `${moment()
    .subtract(30, "days")
    .format("YYYY-MM-DD")} 00:00:00`;
  return `${startDate},${endDate}`;
}

export const getCookieByDomain = () => {
  const hostname = window.location.hostname;
  let tokenName = "accessToken";
  if (
    hostname?.startsWith("stage-") ||
    hostname.includes("dev") ||
    hostname?.startsWith("ui-components-playground")
  ) {
    tokenName = "stageAccessToken";
  }
  const allCookies = `; ${document.cookie}`;
  const parts = allCookies.split(`; ${tokenName}=`);
  if (parts?.length === 2) {
    return parts
      .pop()
      .split(";")
      .shift();
  }
};

export const getUrlObject = () => {
  // Get the current URL
  const currentURL = window.location.href;

  // Create a URL object
  const urlObject = new URL(currentURL);

  return urlObject;
};

export const getStatusTab = (status = "") => {
  const _status = Object.values(BuildTestTabs).find(tab => {
    return tab?.toLowerCase() === status?.toLowerCase();
  });
  if (_status) {
    return _status;
  }

  if (
    BuildTestGroups.Processing.find(
      _status => _status?.toLowerCase() === status?.toLowerCase()
    )
  ) {
    return BuildTestTabs.RUNNING;
  }

  if (
    BuildTestGroups.Other.find(
      _status => _status?.toLowerCase() === status?.toLowerCase()
    )
  ) {
    return BuildTestTabs.OTHER;
  }
  return BuildTestTabs.BUILD_SESSIONS;
};

export const getBucketByRegion = (
  dataLocalisationMapping,
  currentTestRegion,
  assetType
) => {
  try {
    if (!dataLocalisationMapping) {
      return "";
    }
    if (!currentTestRegion || dataLocalisationMapping?.length === 0) {
      return "";
    }
    const regionConfig = dataLocalisationMapping.find(
      regionInfo => regionInfo.region === currentTestRegion
    );
    if (!regionConfig) {
      return "";
    }

    const bucketInfoList = regionConfig["meta"]["real-device"]["artefacts"];
    const bucketInfoForType = bucketInfoList.find(
      bucketInfo => bucketInfo.type === assetType
    );
    return bucketInfoForType.cfDistribution;
  } catch {
    return "";
  }
};

export const getBucketUrlForRealDevice = ({
  assetType = "video",
  dataLocalisation = [],
  fallbackEndpoint = {},
  testRegion,
  hidePublicLinks = false,
  isWasabiEnabled = false
}) => {
  const url = getBucketByRegion(dataLocalisation, testRegion, assetType);
  if (url) {
    return url;
  }

  if (isWasabiEnabled) {
    const wasabiUrl = getUrlByUserDomain(
      process.env.REACT_APP_REAL_MOBILE_R2_CDN,
      "https",
      process.env.REACT_APP_HIDE_PUBLIC_LINKS
    );
    if (wasabiUrl) {
      return wasabiUrl;
    }
  }

  const realMobileArtefactsUrl = getUrlByUserDomain(
    fallbackEndpoint,
    "https",
    hidePublicLinks
  );
  return realMobileArtefactsUrl;
};

export const getUrlByRetention = ({
  urlSuffixToAppend,
  testDetails = {},
  url = "",
  defaultRetentionDays = null
}) => {
  const featureFlags = testDetails?.feature_flag || {};
  const retentionDays = defaultRetentionDays || featureFlags?.retention_days;
  if (retentionDays) {
    const orgPath = getOrgPath(testDetails, true /* useTwoDigitDayFormat */);
    if (orgPath) {
      return `${url}/${retentionDays}d/${orgPath}`;
    }
    return `${url}/${retentionDays}d`;
  }
  if (urlSuffixToAppend) {
    return `${url}/${urlSuffixToAppend}`;
  }
  return `${url}`;
};

export function updateAriaLive(updatedText, id = "lt-aria-live") {
  // aria live element is added in index.html
  const ariaLiveElem = document.getElementById(id);
  if (ariaLiveElem) {
    ariaLiveElem.removeAttribute("inert");
    ariaLiveElem.innerText = updatedText || "";
  } else {
    console.error("Aria Live Element Missing");
  }
}

export const userLocalStorage = {
  setItem: (id, key, value) => {
    const storeValue = localStorage.getItem(key);
    try {
      const dataObject = (storeValue && JSON.parse(storeValue)) || {};
      dataObject[id] = value;
      localStorage.setItem(key, JSON.stringify(dataObject));
    } catch (e) {
      const dataObject = {};
      dataObject[id] = value;
      localStorage.setItem(key, JSON.stringify(dataObject));
    }
  },
  getItem: (id, key) => {
    try {
      const dataObject = JSON.parse(localStorage.getItem(key));
      return dataObject?.[id];
    } catch (e) {
      return false;
    }
  }
};

export const getAndroidLiveVideoUrl = testId => {
  const androidVideoUrl = getUrlByUserDomain(
    process.env.REACT_APP_ANDROID_LIVE_VIDEO,
    "https",
    process.env.REACT_APP_HIDE_PUBLIC_LINKS
  );
  return `${androidVideoUrl}/?testid=${testId}${process.env
    .REACT_APP_IFRAME_URL_APPEND || ""}&q=${window.location.host}`;
};

export const deleteObjectById = (array = [], key, idToDelete) => {
  const data = [...array];
  const index = data.findIndex(obj => obj[key] === idToDelete);
  if (index !== -1) {
    data.splice(index, 1);
  }
  return data;
};

export function isHyExOnPremDomain() {
  const hostname = window.location.hostname;
  return (
    hostname.includes("hyperexecute.cloud") ||
    window?._env_?.REACT_APP_HYPER_EXECUTE_CLOUD_DOMAIN === "true"
  );
}

export const truncateTextFromMiddle = (textToTrim, maxLength) => {
  if (textToTrim?.length <= maxLength) {
    return textToTrim;
  }
  const ellipsis = "...";
  const halfMaxLength = Math.floor((maxLength - ellipsis?.length) / 2);
  const firstHalf = textToTrim.slice(0, halfMaxLength);
  const secondHalf = textToTrim.slice(-halfMaxLength);
  return `${firstHalf}${ellipsis}${secondHalf}`;
};

export const isAndroidOrIosTestRunning = testDetails => {
  return (
    testDetails &&
    !testDetails.isRealMobile &&
    (testDetails?.environment?.category === "android" ||
      testDetails?.category === "android" ||
      testDetails?.environment?.category === "ios" ||
      testDetails?.category === "ios") &&
    !isCDPTest(testDetails?.type) &&
    testDetails?.statusInd?.toLowerCase() === "running"
  );
};

export const safeParseJwt = jwt => {
  try {
    return JSON.parse(atob(jwt.split('.')[1]));
  } catch (e) {
    console.error('Failed to parse token.', e);
    return {};
  }
};

export const getOrdinalSuffix = number => {
  const suffixes = ["th", "st", "nd", "rd"];
  const modulo10 = number % 10;
  const modulo100 = number % 100;

  if (modulo100 >= 11 && modulo100 <= 13) {
    return suffixes[0]; // 11th, 12th, 13th, etc.
  }

  switch (modulo10) {
    case 1:
      return suffixes[1]; // 1st
    case 2:
      return suffixes[2]; // 2nd
    case 3:
      return suffixes[3]; // 3rd
    default:
      return suffixes[0]; // 4th, 5th, 6th, etc.
  }
};

// this bypasses the webpack console func removal
export const debugLogger = (() => {
  return {
    info: (...args) => {
      if (window.enableDebugLogs) {
        console.log(...args);
      }
    },
    error: (...args) => {
      if (window.enableDebugLogs) {
        console.error(...args);
      }
    },
    warn: (...args) => {
      if (window.enableDebugLogs) {
        console.warn(...args);
      }
    }
  };
})();

export const isTrue = data => {
  return (typeof data === "boolean" && data) || data === "true";
};

export const isMp4VideoFeatureEnabled = feature_flag => {
  const {
    ml_mp4_video_live_command_log,
    "hye-video-live-streaming": hyp_live_video
  } = feature_flag || {};
  return isTrue(ml_mp4_video_live_command_log) || isTrue(hyp_live_video);
};

export const isSDKStreamEnabled = feature_flag => {
  return (
    get(
      feature_flag,
      ["ml_enable_new_live_stream_sdk", "variant", "key"],
      "false"
    ) === "true"
  );
};

export const isLiveEnabledForHyEx = feature_flag => {
  const { "hye-video-live-streaming": hyp_live_video } = feature_flag || {};
  return isTrue(hyp_live_video);
};

export const isLiveRerunTest = testDetail => {
  const { status, parentTestDetails = {}, testResult = null } =
    testDetail || {};

  const { parentTestId = "" } = parentTestDetails || {};

  return (
    !!parentTestId &&
    !testResult &&
    status.toLowerCase() === TestStatusMap.RUNNING
  );
};

export const formatTimestampToDateAndTime = timestamp => {
  if (!timestamp) {
    return;
  }

  const date = new Date(timestamp);

  const pad = n => String(n).padStart(2, "0");
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  const day = pad(date.getDate());
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = String(date.getFullYear()).slice(-2);

  return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatDateForSQLQuery = date => {
  if (!date) {
    return;
  }
  // Format as ISO string but using local system timezone instead of UTC
  return moment(date).format("YYYY-MM-DDTHH:mm:ss");
};

export const getCurrentTimezoneString = () => {
  const timezoneOffset = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
  const offsetMinutes = Math.abs(timezoneOffset) % 60;
  const offsetSign = timezoneOffset <= 0 ? "+" : "-";
  return `${offsetSign}${String(offsetHours).padStart(2, "0")}:${String(
    offsetMinutes
  ).padStart(2, "0")}`;
};

export const isTestADemoTest = testId => {
  if (testId) {
    return DemoTestIds.includes(testId);
  }
  return false;
};

export const isNewAnnotationFlowEnabled = testDetails => {
  return (
    isTrue(
      get(testDetails?.feature_flag, ["ml_new_annotation_command_logic"], false)
    ) &&
    testDetails?.type === TestTypes.SELENIUM &&
    testDetails?.annotations &&
    testDetails?.annotations?.length
  );
};

export const isTunnelActivated = (testDetails, tunnelCapability) => {
  if (!testDetails) return null;

  if (isCDPTest(testDetails.type) && testDetails.mode === "hypertest") {
    return tunnelCapability ? true : null;
  }

  return get(testDetails, 'tunnelIdentifier', null) &&
    (tunnelCapability || testDetails.type === 'cypress')
      ? testDetails.tunnelIdentifier !== '0'
      : null;
};